/* @ngInject */
function TaskAssigneesController ($scope, $timeout, $attrs, UserService) {
  const api = {
    _initTooltip
  }
  this.getApi = () => api

  activate()

  function activate () {
    api._initTooltip()
  }

  $scope.getAssigneesTooltip = (assignees) => {
    if (!assignees?.length) return

    let text = ''

    assignees.forEach((assignee, index) => {
      text += `${assignee.name}<br>`
    })

    return text
  }

  $scope.getAvatarUrl = (user) => {
    if (!user || !user.id) return null
    return UserService.getUserProfileImage(user.id)
  }

  function _initTooltip () {
    $timeout(() => {
      $($attrs.$$element).popup({
        delay: {
          show: 1000,
          hide: 0
        }
      })
    }, 250, false)
  }
}

export { TaskAssigneesController }
